module.exports = __webpack_public_path__ + "img/upside.cb3ca7af.png";